/** Standalone page generated by scripts/sync-docs.js from the topcon-ai-core source */
export const VERSION_DETAILS_URL = `${process.env.PUBLIC_URL}/docs/SUPPORT-BRIEFINGS.html`;

/** Text only the details page has: a missing file falls back to the SPA's index.html, which lacks it */
const VERSION_DETAILS_MARKER = "const BRIEFINGS";

/** Widest interval the summary accepts, in version lines (1.19 + 1.20) */
export const MAX_RANGE_LINES = 2;

/**
 * Hash that opens the details page on the summary of an interval. One version is an interval
 * that starts and ends on it.
 */
export const versionRangeHash = (from: string, to: string): string => `range-${from}-${to}`;

/**
 * Fetches the details page and lists the version lines it documents ("1.20").
 * @returns The lines, or null when the page is not published in this build
 */
export const fetchDetailedLines = async (): Promise<string[] | null> => {
  try {
    const response = await fetch(VERSION_DETAILS_URL);

    if (!response.ok) return null;

    const html = await response.text();

    if (!html.includes(VERSION_DETAILS_MARKER)) return null;

    const lines: string[] = [];
    const regex = /\bid: "(\d+)-(\d+)"/g;
    let match = regex.exec(html);

    while (match !== null) {
      lines.push(`${match[1]}.${match[2]}`);
      match = regex.exec(html);
    }

    return lines;
  } catch (err) {
    return null;
  }
};
